import { steps } from "../data/landingData";

export default function StepsOverview() {
  return (
    <section id="steps" className="section steps-overview">
      <h2 className="section-title section-title--accent">
        Trois étapes, et c&apos;est réglé
      </h2>
      <div className="steps-grid">
        {steps.map((s, i) => (
          <div key={i} className="step-card">
            <span className="step-num">{s.num}</span>
            <h3 className="step-title">{s.title}</h3>
            <p className="step-desc">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
